import { render, staticRenderFns } from "./DashboardSidebar.vue?vue&type=template&id=58313fb2&scoped=true&"
import script from "./DashboardSidebar.vue?vue&type=script&lang=ts&"
export * from "./DashboardSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardSidebar.vue?vue&type=style&index=0&id=58313fb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58313fb2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VDivider,VIcon})
